// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"de3b0495","296":"fb9dc58f","305":"13d35979","379":"63a23ebf","403":"cfe17c06","465":"35148891","503":"bb88fea1"}[chunkId] + ".chunk.js";
};